const ADDRESS_COMPONENTS = {
  subpremise: { key: 'unit', value: 'short_name' },
  street_number: { key: 'streetNo', value: 'short_name' },
  route: { key: 'street', value: 'long_name' },
  locality: { key: 'suburb', value: 'long_name' },
  sublocality: { key: 'suburb', value: 'long_name' },
  sublocality_level_1: { key: 'suburb', value: 'long_name' },
  postal_town: { key: 'suburb', value: 'long_name' },
  administrative_area_level_1: { key: 'state', value: 'short_name' },
  administrative_area_level_2: { key: 'council', value: 'long_name' },
  country: { key: 'country', value: 'long_name' },
  postal_code: { key: 'postCode', value: 'short_name' }
}

export const FlewidTextFieldHelper = {
  formatLine1(data) {
    if (data.unit && data.streetNo) {
      return `${data.unit}/${data.streetNo} ${data.street}`
    } else if (data.streetNo) {
      return `${data.streetNo} ${data.street}`
    }
    return data.street
  },

  formatGooglePlaceResult(place) {
    if (
      !place ||
      !Array.isArray(place.address_components) ||
      !place.geometry?.location
    ) {
      return null
    }

    const returnData = {}
    for (let i = 0; i < place.address_components.length; i++) {
      const addressComponent = place.address_components[i]
      for (let j = 0; j < addressComponent.types.length; j++) {
        const addressType = addressComponent.types[j]
        const addressComponentType = ADDRESS_COMPONENTS[addressType]
        if (addressComponentType && !returnData[addressComponentType.key]) {
          returnData[addressComponentType.key] =
            addressComponent[addressComponentType.value]
        }
      }
    }
    returnData.line1 = this.formatLine1(returnData)
    returnData.latitude = place.geometry.location.lat()
    returnData.longitude = place.geometry.location.lng()
    return returnData
  }
}
